export function rupiah(v) {
  const n = Number(v || 0);
  return "Rp " + n.toLocaleString("id-ID", { maximumFractionDigits: 0 });
}

const BULAN = [
  "Januari","Februari","Maret","April","Mei","Juni",
  "Juli","Agustus","September","Oktober","November","Desember",
];

export function tanggalID(iso) {
  if (!iso) return "-";
  const s = toDateInput(iso);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (!m) return iso;
  return `${Number(m[3])} ${BULAN[Number(m[2]) - 1]} ${m[1]}`;
}

const pad2 = (n) => String(n).padStart(2, "0");

// Tanggal hari ini (zona waktu lokal pengguna, bukan UTC) format YYYY-MM-DD
export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

// Normalisasi nilai tanggal dari API (mis. "2026-07-18", "2026-07-18T00:00:00.000000Z",
// "2026-07-17T17:00:00.000000Z") menjadi "YYYY-MM-DD" agar <input type="date"> tidak kosong saat edit.
export function toDateInput(v) {
  if (!v) return "";
  const s = String(v).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  if (/^\d{4}-\d{2}-\d{2}[T ]00:00(:00)?/.test(s)) return s.slice(0, 10);
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return /^\d{4}-\d{2}-\d{2}/.test(s) ? s.slice(0, 10) : "";
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}
